export default "__VITE_ASSET__BeNZXLZk__"